"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EmailSquircleFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_EmailSquircleFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.436 2.184C0 3.04 0 4.16 0 6.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C3.04 16 4.16 16 6.4 16h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 12.96 16 11.84 16 9.6V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 13.816.436C12.96 0 11.84 0 9.6 0H6.4C4.16 0 3.04 0 2.184.436A4 4 0 0 0 .436 2.184ZM3.02 5.126a.943.943 0 0 1 .089-.33 1 1 0 0 1 .437-.437C3.76 4.25 4.04 4.25 4.6 4.25h6.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437.942.942 0 0 1 .089.33l-3.887 3.11a1.75 1.75 0 0 1-2.186 0L3.02 5.125Zm6.698 3.89L13 6.39v3.76c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 10.99 3 10.71 3 10.15V6.39l3.282 2.626a2.75 2.75 0 0 0 3.436 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_EmailSquircleFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = EmailSquircleFill;
exports["default"] = _default;